import { FieldPath, FieldValues, useController } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { RhfInputProps } from "./RhfInputProps";
import { isElementInArray } from "../Utils/arrays";
import { selectDefaultProps } from "./selectDefaultProps";
import { toKeyValuePairArray } from "../Utils/maps";
import { RHFFieldErrorText } from "./RHFFieldErrorText";
import { emptyMenuItem } from "./SelectDefaultComponents";

interface RhfEnumSelectProps {
  onSelectionChange?: (item: unknown) => void;
  disabledFields?: Array<string>;
  options: Map<number, string>;
  label?: string;
}

export const RhfEnumSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  options,
  onSelectionChange,
  disabledFields,
  label,
  ...otherProps
}: RhfInputProps<TFieldValues, TName> & RhfEnumSelectProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <FormControl fullWidth size="small" disabled={isElementInArray(disabledFields, name)}>
      <InputLabel shrink required>
        {label ?? name}
      </InputLabel>
      <Select
        {...selectDefaultProps}
        {...otherProps}
        {...field}
        label={label ?? name}
        notched
        required
        disabled={isElementInArray(disabledFields, name)}
        onChange={(event) => {
          field.onChange(event);
          onSelectionChange?.(event.target.value);
        }}
        error={!!error}
      >
        {emptyMenuItem(-1)}
        {toKeyValuePairArray(options).map((enumType) => (
          <MenuItem key={enumType.Key} value={enumType.Key}>
            {enumType.Value}
          </MenuItem>
        ))}
      </Select>
      {!!error && <RHFFieldErrorText fieldError={error} />}
    </FormControl>
  );
};
